<div class="page-outer-wrapper">

  <div class="admin-page-header">
    <div class="hamburger">
      <img (click)="toggleSidebar()" style="cursor: pointer;" src="/assets/images/menu-512.png" height="28" width="28">
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>

  <div class="page-content-background">

    <div class="page-content">

      <mat-sidenav-container id="admin-content-wrapper" class="admin-content-wrapper">

        <mat-sidenav #adminsidenav class="admin-sidebar">

          <admin-sidebar></admin-sidebar>

        </mat-sidenav>

        <mat-sidenav-content>

          <!-- [START] page content -->

          <mat-card style="width: 100%; display: block;">

            <mat-card-header>
              <mat-card-title>Projects</mat-card-title>
            </mat-card-header>

            <mat-card-content style="padding-left: 16px;">

              <p style="width: 650px;">To create a new Project use the Create input below.
                Note that projects require a unique key and a name.  The unique key can start with A-Z,
                and the rest of the key can be _, A-Z, or 0-9.  All projects must also belong to an
                organization.
              </p>

              <div>

                <p-inputgroup>

                  <p-dropdown
                      id="orglistpicker"
                      class="dark"
                      [disabled]="orgOptions().length == 0"
                      [options]="orgOptions()"
                      autoDisplayFirst="true"
                      optionLabel="name"
                      optionValue="id"
                      [(ngModel)]="selectedOrg"
                      scrollHeight="200"
                      (onChange)="orgChange($event)"
                  >
                  </p-dropdown>

                  <input style="width: 80px;" (keyup)="checkKey()" id="createprojectkey" type="text" pInputText placeholder="Key">

                  <input style="width: 200px;" (keyup)="checkKey($event)" id="createproject" type="text" pInputText placeholder="New Project">

                  <p-button
                    style="height: 32px;"
                    (click)="createProject()"
                    type="button"
                    pButton
                    pRipple
                    icon="pi pi-check"
                    [class.p-button-danger]="!prjInputValid"
                    [class.p-button-success]="prjInputValid"
                  >
                  </p-button>

                </p-inputgroup>
                <div>
                  <p class="prjcreateerror"></p>
                </div>
              </div>

              <p style="width: 650px;">You can manage existing projects by updating the name or soft deleting.
                To change the name, just click the name and edit inline.  To jump to the project page, click
                the project key.  To jump to an project admin's profile page, click their email address.
              </p>

              <p-table  class="admin-dark-table" selectionMode="single"  sortField="name"  [value]="projects" (sortFunction)="tableSort($event)" [customSort]="true">

                <ng-template pTemplate="header">
                  <tr style="background-color: #2D323D;">
                    <th width="80" pSortableColumn="id">ID<p-sortIcon field="id"></p-sortIcon></th>
                    <th pSortableColumn="key" style="width: 100px;">KEY<p-sortIcon field="key"></p-sortIcon></th>
                    <th pSortableColumn="name">Name<p-sortIcon field="name"></p-sortIcon></th>
                    <th style="width: 100px;">Status</th>
                    <th style="width: 200px;">Admins</th>
                    <th style="width: 116px;"># Members</th>
                    <th style="width: 100px;"># Subs</th>
                    <th style="width: 200px;" pSortableColumn="created_at">Created<p-sortIcon field="created_at" ></p-sortIcon></th>
                    <th style="width: 90px;">Actions</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-prj>

                  <tr [className]="'userListrowWrapper'" >

                    <!-- OID -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{prj.id}}</td>

                    <!-- key -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">
                      <span class="orglist-key-span"><a href="project/{{prj.key}}">{{prj.key}}</a></span>
                      <span class="orglist-keyorg-span">(<a href="organization/{{prj.organization.key}}">{{prj.organization.key}}</a>)</span>
                    </td>

                    <!-- name -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">

                      <!-- allow inline editing on the name -->

                      <p-inplace
                        #component
                        class="prjclass-{{prj.id}}"
                        closable="closable"
                        (onDeactivate)="prjEditDeactivate(prj.id, component)"
                        (onActivate)="prjEditActivate(prj.id, component)"
                        (keyup)="prjEditKey($event, prj.id, component)">
                        <ng-template pTemplate="display">
                          {{ prj.name }}
                        </ng-template>
                        <ng-template pTemplate="content">
                          <input type="text" value="{{prj.name}}" pInputText>
                        </ng-template>
                      </p-inplace>

                    </td>

                    <!-- status -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">

                      <div *ngIf="prj.is_deleted; then thenDeleted"></div>

                      <ng-template #thenDeleted>
                        <p-tag *ngIf="prj.is_deleted" severity="danger" value="Deleted" class="userlisttag"></p-tag>
                      </ng-template>

                    </td>

                    <!-- admins -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">

                      <span
                        class="orglist-email-span"
                        *ngFor="let admin of prj.admins">
                        <a href="users/{{admin.key}}">{{admin.email}}</a>
                      </span>

                    </td>

                    <!-- usage metrics -->

                    <td>{{prj.members.length}}</td>
                    <td>{{prj.subdivisions.length}}</td>

                    <!-- inception -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{prj.created_at}}</td>

                    <!-- available actions -->

                    <td style="font-size: 10px;">

                      <div *ngIf="prj.is_deleted; then thenBlock else elseBlock"></div>

                      <ng-template #thenBlock>

                        <!-- if the user was deleted, the ONLY thing you can do is undelete them. -->

                        <a class="useractionicon" (click)="unDeleteProject(prj.id)">
                          <img width="16" title="Activate" src="assets/images/undelete-64.png">
                        </a>

                      </ng-template>

                      <ng-template #elseBlock>

                        <!-- soft delete (but only if no usage) -->

                        <a *ngIf="canDelete(prj.id)" class="useractionicon" (click)="deleteProject(prj.id)">
                          <img width="16" title="Soft Delete" src="assets/images/delete-64.png">
                        </a>

                      </ng-template>

                    </td>

                  </tr>

                </ng-template>

              </p-table>

            </mat-card-content>

          </mat-card>

        </mat-sidenav-content>

      </mat-sidenav-container>

    </div>

    <div id="pano-footer" class="pano-footer"></div>

  </div>

</div>
